<div class="snackbar" [ngClass]="{
    'show': (snackbarService.show$ | async),
    'hide': !(snackbarService.show$ | async),
    'success': snackbarService.type$.value === SnackbarStatus.SUCCESS,
    'error': snackbarService.type$.value === SnackbarStatus.ERROR}">
    <div class="content">
        <div class="text-section">

            <div class="text" [ngClass]="{
                'small-text': (snackbarService.smallFont$ | async),
                'switch': (switch$ | async)
            }">
                {{ mainMessage$ | async }}
            </div>
            <div *ngIf="(previousMessage$ | async) as message" class="text previous">
                {{ message }}
            </div>
        </div>
    </div>
</div>